// src/components/common/ProtectedRoute/ProtectedRoute.js - Updated with new color scheme
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { Box, Typography } from '@mui/material';
import LoginPage from '../../../pages/auth/LoginPage';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import { COLORS } from '../../../utils/color';

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { isAuthenticated, loading, user, hasRole } = useAuth();
  const navigate = useNavigate();

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          background: COLORS.gradients.background,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <LoadingSpinner 
          message="Checking your authentication status..." 
          size={60} 
        />
      </Box>
    );
  }

  // Check if user is authenticated
  if (!isAuthenticated) {
    return <LoginPage onBack={() => navigate('/')} />;
  }

  // Check role-based access if required
  if (requiredRole && !hasRole(requiredRole)) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          background: COLORS.gradients.background,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 2,
        }}
      >
        <Box sx={{ textAlign: 'center', maxWidth: 'sm' }}>
          <Typography variant="h4" sx={{ color: COLORS.status.error, mb: 2, fontWeight: 700 }}>
            Access Denied
          </Typography>
          <Typography variant="body1" sx={{ color: COLORS.text.secondary, mb: 2 }}>
            You don't have permission to access this page.
          </Typography>
          <Typography variant="body2" sx={{ color: COLORS.primary.main }}>
            Required role: {requiredRole}
          </Typography>
          <Typography variant="body2" sx={{ color: COLORS.text.secondary }}>
            Your role: {user?.role || 'Unknown'}
          </Typography>
        </Box>
      </Box>
    );
  }

  // User is authenticated and has required role (if any)
  return children;
};

export default ProtectedRoute;